/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Type kind of the charging profile
 */
export enum ChargePointChargingProfileKindType {
  ABSOLUTE = 'ABSOLUTE',
  RELATIVE = 'RELATIVE',
  RECURRING = 'RECURRING'
}
